class NotSupportedError extends Error {
    constructor(message) {
        super(message);
        this.name = "NotSupportedError";
    }
}

export default NotSupportedError;
